import { Typography } from "@mui/material";

function Header() {
  return (
    <Typography component="h1" variant="h5">
      Dashboard
    </Typography>
  );
}

export default Header;
